import { Box, Button, Grid, Typography } from "@mui/material";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import AppForm from "components/Shared/AppForm";
import BaseSwitch from "components/Shared/Base/BaseSwitch";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { BASE_CONSTANTS } from "constants/baseConstants";
import { useEntityDetailContext } from "contexts/EntityDetailContext";
import React from "react";
import { HexColorPicker } from "react-colorful";
import { Controller, useForm } from "react-hook-form";

const INITIAL_STATE = {
  domain: "",
  enableBranding: true,
  brandPrimary: "",
  brandSecondary: "",
};

export const EntityBrandingForm = ({
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  const { entityDetail } = useEntityDetailContext();

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  const _selectedBranding = watch("enableBranding");

  React.useEffect(() => {
    if (!entityDetail) return reset(INITIAL_STATE);
    reset({
      ...entityDetail,
    });
  }, [entityDetail, reset]);

  return (
    <AppForm loading={isBusy}>
      <InnerShadowBox>
        <AppForm.Content>
          <Grid container spacing={BASE_CONSTANTS.SPACING_LG}>
            <Grid item xs={12}>
              <Controller
                name="domain"
                control={control}
                rules={{
                  required: "Please provide domain.",
                }}
                render={({ field }) => (
                  <BaseTextField
                    {...field}
                    required
                    fullWidth
                    label="domain"
                    placeholder="Enter Domain"
                    error={!!errors?.domain}
                    helperText={errors?.domain?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="enableBranding"
                control={control}
                render={({ field }) => (
                  <BaseSwitch {...field} label="Enable Branding" />
                )}
              />
            </Grid>
            {_selectedBranding && (
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <Typography variant="overline">Primary Color</Typography>
                    <Controller
                      name="brandPrimary"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <HexColorPicker
                            {...field}
                            color={field.value}
                            onChange={field.onChange}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              gap: 2,
                              paddingTop: 2,
                            }}
                          >
                            <Box
                              sx={{
                                background: field.value,
                                width: "36px",
                                height: "30px",
                                borderRadius: "5px",
                                border: "1px solid #dedede",
                              }}
                            ></Box>
                            <input
                              style={{ width: "150px", height: "30px" }}
                              className="form-control form-font"
                              type="text"
                              value={field.value}
                              {...register("brandPrimary")}
                            />
                          </Box>
                        </>
                      )}
                    />
                    {errors?.brandPrimary && (
                      <p className="error">{"Primary color is required."}</p>
                    )}
                  </Grid>
                  <Grid item sm={6}>
                    <Typography variant="overline">Secondary Color</Typography>
                    <Controller
                      name="brandSecondary"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <HexColorPicker
                            {...field}
                            color={field.value}
                            onChange={field.onChange}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              gap: 2,
                              paddingTop: 2,
                            }}
                          >
                            <Box
                              sx={{
                                background: field.value,
                                width: "36px",
                                height: "30px",
                                borderRadius: "5px",
                                border: "1px solid #dedede",
                              }}
                            ></Box>
                            <input
                              style={{ width: "150px", height: "30px" }}
                              className="form-control form-font"
                              type="text"
                              value={field.value}
                              {...register("brandSecondary")}
                            />
                          </Box>
                        </>
                      )}
                    />
                    {errors?.brandSecondary && (
                      <p className="error">{"Secondary color is required."}</p>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </AppForm.Content>
      </InnerShadowBox>
      <AppForm.Actions>
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          disabled={isBusy}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
        >
          Update
        </Button>
      </AppForm.Actions>
    </AppForm>
  );
};
